import React from "react"
import { SummaryType } from '@ls/grouping-service';
import { exchange, useQuery } from '@ls/js-fetch';
import { selectDefinitions, selectFetchingData, selectFetchingScenarioAnalysisSbsData } from 'state/scenarioAnalysis/selectors';
import { useDispatch, useSelector } from 'react-redux';
import CalcType from 'state/Constants/CalcType';
import SelectionState from 'state/selections/SelectionState';
import { selectSideBySideValue } from "state/selections/selectors";
import { DELETE_DEFINITION } from './actions';
export const useScenarioAnalysisOptionsQuery = () => {
  return useQuery(['scenarioAnalysis'], async () => {
    const result = await exchange({
      baseURL: process.env.REACT_APP_BASE_URL_GROUPING_SERVICE,
      url: 'scenarios?appName=' + process.env.REACT_APP_ID,
    });
    const scenarioAnalysisOptions = result?.data ?? [];
    return {
      scenarioAnalysisOptions,
      scenarioAnalysisOptionsById: scenarioAnalysisOptions.reduce((map, scenarioAnalysisOption) => {
        map[scenarioAnalysisOption.id] = scenarioAnalysisOption;
        return map;
      }, {}),
    }
  });
}

export const useColumnDefs = () => {
  const definitions = useSelector(selectDefinitions(SelectionState.COMMITTED));
  const fetchingAbsData = useSelector(selectFetchingData(SummaryType.ABSOLUTE));
  const fetchingRelData = useSelector(selectFetchingData(SummaryType.RELATIVE));
  const fetchingAbsScenarioAnalysisSbsData = useSelector(
    selectFetchingScenarioAnalysisSbsData(SummaryType.ABSOLUTE)
  );
  const fetchingRelScenarioAnalysisSbsData = useSelector(
    selectFetchingScenarioAnalysisSbsData(SummaryType.RELATIVE)
  );
  const sideBySideValue = useSelector(
    selectSideBySideValue(SelectionState.COMMITTED)
  );
  const { data } = useScenarioAnalysisOptionsQuery();
  const scenarioAnalysisOptionsById = data?.scenarioAnalysisOptionsById;
  const scenarioOptions = !!scenarioAnalysisOptionsById && Object.values(scenarioAnalysisOptionsById)
  const dispatch = useDispatch();
  return React.useMemo(() => {
    return definitions.reduce((columnDefs, definition) => {
      const { scenarioAnalysisId, scenarioAnalysisFactor, calcType, scenarioType, key } = definition;
      // const betaEntity = betasByBetaId?.[betaId];
      const scenarioLabel = scenarioOptions.filter((obj) => obj.id === scenarioAnalysisId)
      const baseHeaderName = `${scenarioLabel[0].name}-${scenarioAnalysisFactor}-${scenarioType}`;
      const columnDef = {
        field: key,
        colId: key,
        X_onDelete: () => dispatch({ type: DELETE_DEFINITION, payload: definition }),
      };
      switch (calcType) {
        case CalcType.Account:
          columnDef.headerName = `${baseHeaderName}\nAcc`;
          columnDef.loading = fetchingAbsData;
          break;
        case CalcType.Relative:
          columnDef.headerName = `${baseHeaderName}\nRel`;
          columnDef.loading = fetchingRelData;
          break;
        case CalcType.Benchmark:
          columnDef.headerName = `${baseHeaderName}\nBench`;
          columnDef.loading = fetchingAbsData && fetchingRelData;
          break;
        default:
          throw Error('Unknown calc type: ' + calcType);
      }
      columnDefs.push(columnDef);
      if (sideBySideValue) {
        const sbsColDef = { ...columnDef };

        sbsColDef.headerName += " - scenario";
        sbsColDef.colId += " - scenario";
        sbsColDef.field += " - scenario";
        switch (calcType) {
          case CalcType.Account:

            sbsColDef.loading = fetchingAbsScenarioAnalysisSbsData;
            break;
          case CalcType.Relative:

            columnDef.loading = fetchingRelScenarioAnalysisSbsData;
            break;
          case CalcType.Benchmark:
            sbsColDef.loading = fetchingAbsScenarioAnalysisSbsData && fetchingRelScenarioAnalysisSbsData;
            break;
          default:
            throw Error('Unknown calc type: ' + calcType);
        }
        sbsColDef.X_sbs = true;
        sbsColDef.X_originalColId = key;
        sbsColDef.X_backgroundColor = "#fffb95";

        columnDefs.push(sbsColDef);
      }
      return columnDefs;
    }, []);
  }, [dispatch, definitions, fetchingAbsData, scenarioOptions, fetchingRelData, sideBySideValue, fetchingAbsScenarioAnalysisSbsData, fetchingRelScenarioAnalysisSbsData]);
}
